export enum UserRole {
    GROUP_ADMIN = 'GROUP_ADMIN',
    COMPANY_ADMIN = 'COMPANY_ADMIN',
    COMPANY_EMPLOYEE = 'COMPANY_EMPLOYEE',
    COMPANY_INSPECTOR = 'COMPANY_INSPECTOR',
    CUSTOM = 'CUSTOM',
}
